import styled from "styled-components";
import { breakpoints } from "../../../../../../shared-logic/themes/toyotaTheme";

export const Wrapper = styled.div`
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: flex-start;
    column-gap: calc(var(--spacing-3) / 2);
    padding-block: var(--spacing-1);
    padding-inline: var(--spacing-2) calc(var(--spacing-3) / 2);
    background-color: var(--color-primary-white);
    border: 1px solid var(--color-grey-6);
    border-radius: 3px;

    @media screen and (min-width: ${breakpoints.xl}) {
        border-color: var(--color-grey-7);
    }

    @supports not (padding-block: 0) {
        margin-top: auto;
        padding: var(--spacing-1) calc(var(--spacing-3) / 2) var(--spacing-1) var(--spacing-2);

        svg {
            margin-right: calc(var(--spacing-3) / 2);
        }
    }
`;

export const Content = styled.div`
    display: flex;
    gap: var(--spacing-1);
    flex-grow: 1;

    @supports not (gap: 0) {
        & > span:not(:nth-last-child(1)) {
            margin-right: var(--spacing-1);
        }
    }
`;

export const Title = styled.span`
    font-family: var(--font-regular);
    font-size: 1.3rem;
    line-height: 2rem;
    color: var(--color-grey-7);
`;

export const Code = styled.span`
    font-family: var(--font-semi-bold);
    font-size: 1.3rem;
    line-height: 2rem;
    color: var(--color-primary-black);
`;
